import React from 'react';

/* ── MiniBar ───────────────────────────────────────────────────────────────── */
export function MiniBar({ pct }) {
  const cls = pct > 90 ? 'danger' : pct > 70 ? 'warn' : '';
  return (
    <div className="bar-wrap">
      <div className="bar-fill" style={{ width: `${Math.min(pct, 100)}%` }}
           data-class={cls || undefined}
           ref={el => { if (el) { el.className = `bar-fill${cls ? ' ' + cls : ''}`; }}} />
    </div>
  );
}

/* ── StatCard ──────────────────────────────────────────────────────────────── */
export function StatCard({ title, value, sub, pct, children }) {
  return (
    <div className="card">
      <div className="card-title">{title}</div>
      {value !== undefined && <div className="card-value">{value}</div>}
      {sub   && <div className="mono muted" style={{ fontSize: 11, marginTop: 4 }}>{sub}</div>}
      {pct   !== undefined && <MiniBar pct={pct} />}
      {children}
    </div>
  );
}

/* ── Badge ─────────────────────────────────────────────────────────────────── */
export function Badge({ label, color }) {
  const clr = color || 'inherit';
  return <span className="badge" style={{ color: clr, borderColor: clr }}>{label}</span>;
}

/* ── Spinner ───────────────────────────────────────────────────────────────── */
export function Spinner() {
  return (
    <div style={{ padding: 40, textAlign: 'center', fontFamily: 'var(--mono)',
                  fontSize: 12, color: 'var(--muted)', letterSpacing: '0.1em' }}>
      LOADING...
    </div>
  );
}

/* ── ErrorBox ──────────────────────────────────────────────────────────────── */
export function ErrorBox({ msg }) {
  return (
    <div style={{ padding: 16, border: '1px solid var(--danger)',
                  fontFamily: 'var(--mono)', fontSize: 12, color: 'var(--danger)' }}>
      {msg}
    </div>
  );
}

/* ── Topbar ────────────────────────────────────────────────────────────────── */
export function Topbar({ user, onLogout, onAdmin }) {
  return (
    <div className="topbar">
      <div className="topbar-logo">SYS<span>MON</span></div>
      <div style={{ fontSize: 11, fontFamily: 'var(--mono)', color: 'var(--muted)', marginLeft: 'auto' }}>
        {user?.username} <span style={{ marginLeft: 6, color: 'var(--border-hi)' }}>[{user?.role}]</span>
      </div>
      <div className="topbar-nav">
        {user?.role === 'admin' && (
          <button className="topbar-btn" onClick={onAdmin}>ADMIN</button>
        )}
        <button className="topbar-btn danger" onClick={onLogout}>LOGOUT</button>
      </div>
    </div>
  );
}

/* ── fmtBytes ──────────────────────────────────────────────────────────────── */
export function fmtBytes(b, decimals = 1) {
  if (!b && b !== 0) return '—';
  if (b === 0) return '0 B';
  const k = 1024;
  const dm = decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(Math.abs(b)) / Math.log(k));
  return `${parseFloat((b / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function fmtUptime(secs) {
  const d = Math.floor(secs / 86400);
  const h = Math.floor((secs % 86400) / 3600);
  const m = Math.floor((secs % 3600) / 60);
  return `${d}d ${h}h ${m}m`;
}
